import { render, staticRenderFns } from "./alertPanicButton.vue?vue&type=template&id=22acd1c6&scoped=true&"
import script from "./alertPanicButton.vue?vue&type=script&lang=js&"
export * from "./alertPanicButton.vue?vue&type=script&lang=js&"
import style0 from "./alertPanicButton.vue?vue&type=style&index=0&id=22acd1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22acd1c6",
  null
  
)

export default component.exports